import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'library/util/core-router';
import { resolve } from 'library/helpers/path-resolver';
import Password from 'library/components/form-elements/password';
import StateSelect from 'library/components/form-elements/state';
import Tag from 'library/components/tag';

class ContactInformation extends React.Component {
    static contextTypes = {
        user: PropTypes.object
    }

    render() {
        const { data, handleChange } = this.props;
        const { user } = this.context;

        return (
            <section className="">
                <h1>Contact Information <Tag>Required for Resume Creation</Tag></h1>
                <p>We’ll add this to your résumé so people will know how to contact you. </p>
                <div className={"resume-builder-fields"}>
                    <label>
                        Phone Number Type
                        <select name="phone_type" onChange={handleChange} value={resolve(data, 'phone_type', '')}>
                            <option value="">--Select One--</option>
                            <option value="home">Home</option>
                            <option value="mobile">Mobile</option>
                            <option value="work">Work</option>
                        </select>
                    </label>
                    <label>
                        Phone Number
                        <input type="tel" name="phone" placeholder="Phone Number" onChange={handleChange} value={resolve(data, 'phone', '')}/>
                    </label>
                    <label>
                        Address
                        <input type="text" name="street" placeholder="Address" onChange={handleChange} value={resolve(data, 'street', '')}/>
                    </label>
                    <label>
                        Address (cont)
                        <input type="text" name="street_2" placeholder="Address (cont)" onChange={handleChange} value={resolve(data, 'street_2', '')}/>
                    </label>
                    <label>
                        City
                        <input type="text" name="city" placeholder="City" onChange={handleChange} value={resolve(data, 'city', '')}/>
                    </label>
                    <label>
                        State
                        <StateSelect name="state" onChange={handleChange} value={resolve(data, 'state', '')} />
                    </label>
                    <label>
                        Postal Code
                        <input type="text" name="zipcode" placeholder="Postal Code" onChange={handleChange} value={resolve(data, 'zipcode', '')}/>
                    </label>
                    <label>
                        Country
                        <input type="text" name="country" placeholder="Country" onChange={handleChange} value={resolve(data, 'country', '')}/>
                    </label>
                </div>
            </section>
        )
    }
}

export default ContactInformation;
